<div class="payment-history-section">
  <h2 mat-dialog-title>Payment History</h2>

  <!-- Payment History Table -->
  <table class="payment-history-table">
    <thead>
    <tr>
      <th>Status</th>
      <th>Date</th>
      <th>Time</th>
      <th>Comments</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let paymentHistory of paymentHistoryList">
      <td><status [status]="paymentHistory.status"></status></td>
      <td>{{ paymentHistory.createdDatetime | date: 'MM/dd/yyyy' }}</td>
      <td>{{ paymentHistory.createdDatetime | date: 'hh:mm a' }}</td>
      <td>
        <div *ngIf="paymentHistory.status == 'REJECTED'" class="rejection-type">
          <span *ngIf="paymentHistory.rejectionType"><strong>Rejection Type: &nbsp;</strong> {{ getRejectionLabel(paymentHistory.rejectionType) }}</span>
          <div *ngIf="!paymentHistory.rejectionType" class="rejection-type-select" style="display: flex; align-items: center; gap: 10px;">
            <mat-select [(ngModel)]="rejectionType" placeholder="Select Rejection Type">
              <mat-option *ngFor="let option of GlobalConstants.REJECTION_TYPE_OPTION_LIST" [value]="option.value">
                {{ option.label }}
              </mat-option>
            </mat-select>
            <button mat-button color="primary" (click)="updateRejectionType(paymentHistory.id)">Update</button>
          </div>
        </div>
        <div *ngFor="let comment of getKeyValuePairs(paymentHistory.comments)" class="comment-panel">
          <p class="comment">{{ comment.value }}</p>
          <small class="date">{{paymentHistory.createdBy}} | {{ comment.key | date: 'MM/dd/yyyy | hh:mm a' }}</small>
        </div>
      </td>
    </tr>
    </tbody>
  </table>

  <!-- Action Buttons -->
  <div mat-dialog-actions class="action-buttons">
    <button mat-button (click)="onCloseClick()">Close</button>
  </div>
</div>
